mutation CreateOverlay($eventId: ID!, $kind: String) {
  overlay: StreamToolsCreateOverlay(eventId: $eventId, kind: $kind) {
    overlayId
    eventId
    kind
    name
    width
    height
    defaultElementScale
    liveSceneId
    liveScene {
      sceneId
      name
      sourceVersion
      takenAt
      elements {
        elementKind
        elementId
        x
        y
        z
        scale
        visible
        w
        h
      }
    }
    sceneOrder
    version
    createdAt
    scenes {
      sceneId
      overlayId
      eventId
      name
      version
      createdAt
      elements {
        elementKind
        elementId
        x
        y
        z
        scale
        visible
        w
        h
      }
    }
  }
}
